export const MIXPANEL_PROXY_HOST = 'https://mactions.app.alison.ai';

export const MIXPANEL_API_HOST = 'https://api-eu.mixpanel.com';
